<template>
  <div>
		 <div class="loading" v-if="loading">
   
<div class="loader">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
    </div>
  <div v-if="fetch">
    <!-- Title page -->
	<h2 class="ltext-105 pt-4 txt-center">
			About Us
	</h2>
		
	<!-- Content page -->
	<section class="bg0 p-t-40 p-b-50">
		<div class="container">
			<div class="row p-b-60">
				<div class="col-md-6">
					<div class="p-t-7 p-r-50 p-l-50 p-r-15-lg p-r-0-md">
						<h3 class="mtext-111 cl2 p-b-16">
							Our Story
						</h3>

						<p class="stext-113 cl6 p-b-26">
							{{about}}
						</p>

						<p class="stext-113 cl6 p-b-26" v-if="address != ''">
							Any questions? Let us know in store at {{address}} or call us on +94{{tel1}}
						</p>
					</div>
				</div>

				<div class="col-11 col-md-5 m-lr-auto" v-if="aboutimg != undefined">
					<div class="how-bor1 ">
						<div class="hov-img0">
							<img :src="aboutimg" alt="IMG">
						</div>
					</div>
				</div>
			</div>
			
		
		</div>
	</section>	

		<Reviews/>

  </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit"
import firebase from "firebase/app"
import Reviews from './Reviews'
export default {
	name: 'about',
	components:{
		Reviews
	},
  data() {
	return{
		 loading: false,
     fetch: false,
	  aboutimg:'',
		shops:[],
		about:'',
		address:'',
		tel1:''
	}
  },
	methods:{
		 backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },
	},
  created(){
		this.backToTop()
		this.loading = true
      this.fetch = false
	  	console.log("navigator.onLine", navigator.onLine)
		db.collection('shops').get()
      	.then(querySnapshot => {
      	querySnapshot.forEach(doc => {
		const data = {
		    'shoptype' : doc.data().shoptype,
			'aboutimg': doc.data().aboutimg,
			'about': doc.data().about, 
			'details': doc.data().details,   
        }
        this.shops.push(data)
			this.aboutimg = this.shops[0].aboutimg
			this.about = this.shops[0].about
			this.address = this.shops[0].details.address
			this.tel1 = this.shops[0].details.tel1
		 
			console.log("details are", this.shops[0].details)
			//console.log("url is", this.url)
			this.loading = false
      this.fetch = true
      })
	})
  }
}
</script>

<style scoped>
 @import url('~@/assets/main/css/loading.css');
 @media (max-width: 767px){
	  h2 {
		  font-size: 30px;
		  padding-top: 4.2rem !important;
	  }
	}
	
</style>




// WEBPACK FOOTER //
// src/components/store/About.vue